import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { toast } from "sonner";
import { TrendingUp } from "lucide-react";

const TrendingPage = () => {
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await api.get("/trending");
        setTopics(response.data || []);
      } catch {
        toast.error("Unable to load trending topics.");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="space-y-6" data-testid="trending-page">
      <div className="space-y-2">
        <h2 className="text-2xl font-semibold" data-testid="trending-title">Trending</h2>
        <p className="text-sm text-muted-foreground" data-testid="trending-subtitle">
          Popular topics in the last 24 hours.
        </p>
      </div>

      {loading ? (
        <div className="text-sm text-muted-foreground" data-testid="trending-loading">
          Loading topics...
        </div>
      ) : topics.length === 0 ? (
        <div
          className="rounded-xl border border-border bg-card p-6 text-sm text-muted-foreground"
          data-testid="trending-empty"
        >
          No trending topics right now. Create some polls to get started.
        </div>
      ) : (
        <div className="flex flex-wrap gap-3" data-testid="trending-topics-list">
          {topics.map((topic) => (
            <button
              key={topic.keyword}
              onClick={() => navigate(`/trending/${encodeURIComponent(topic.keyword)}`)}
              className="group flex items-center gap-2 rounded-xl border border-border bg-card px-4 py-3 text-left transition hover:border-primary hover:shadow-sm"
              data-testid={`trending-topic-${topic.keyword}`}
            >
              <TrendingUp className="h-4 w-4 text-primary shrink-0" />
              <div>
                <div className="text-sm font-semibold group-hover:text-primary transition">
                  {topic.keyword}
                </div>
                <div className="text-xs text-muted-foreground">
                  {topic.poll_count} poll{topic.poll_count !== 1 ? "s" : ""}
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrendingPage;
